import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import React from 'react';

import unitValue from '../../util/unitValue';
import InputGroup from './InputGroup';

const Input = styled.input`
    border: 0;
    width: 100%;
    height: 38px;
    padding: 5px;
    background: transparent;
    color: ${({ isPale, theme }) => (isPale ? theme.disabledText : 'inherit')};

    &:focus {
        outline: 0;
        border-color: #80bdff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25) inset;
    }
`;

const InputWrap = styled.div`
    position: relative;
    border-radius: 5px;
    width: ${({ width }) => width || '100%'};
    background: ${({ theme }) => theme.inputBg};
    border: 1px solid ${({ theme }) => theme.inputBorder};
`;
const NumberControls = styled.div`
    flex-direction: column;
    position: absolute;
    height: 100%;
    display: flex;
    right: 0;
    top: 0;

    button {
        background-color: ${({ theme }) => theme.primary.bg};
        border-color: ${({ theme }) => theme.inputBorder};
        border-width: 0 0 1px 1px;
        justify-content: center;
        align-items: center;
        border-style: solid;
        cursor: pointer;
        display: flex;
        width: 20px;
        padding: 0;
        flex: 1;

        &:focus {
            outline: none;
        }

        &:first-of-type {
            border-top-right-radius: 5px;
        }

        &:last-of-type {
            border-bottom-right-radius: 5px;
            border-bottom: 0;
        }
    }

    svg {
        vertical-align: 0;
        height: 10px;
        width: 10px;
    }
`;

const UnitInput = React.memo(props => {
    const {
        type,
        name,
        value,
        width,
        inputId,
        onChange,
        placeholder,
        defaultUnit,
        defaultValue = '',
        allowedUnits,
        mqPlaceholder,
    } = props;
    const defaultVal = value === undefined ? defaultValue : value;
    // TODO: start increment from min value
    // TODO: should not exceed max value
    const withArrows = type === 'numeric';
    const inputType = withArrows || !type ? 'text' : type;
    const className = `${withArrows ? 'form-control--with-arrow' : ''}`;
    let unitType = '';
    if (defaultUnit) {
        unitType = defaultUnit;
    }

    const getUnit = inputUnit => {
        const unit = inputUnit || unitType;
        if (!allowedUnits) return unit;
        return allowedUnits.includes(unit) ? unit : allowedUnits[0];
    };

    const handleChange = value => {
        onChange({ name, value });
    };

    const increment = () => {
        const [num, unit] = unitValue(value);
        const newValue = `${num + 1}${getUnit(unit)}`;
        handleChange(newValue);
    };
    const decrement = () => {
        const [num, unit] = unitValue(value);
        const newValue = `${num - 1}${getUnit(unit)}`;
        handleChange(newValue);
    };

    const handleBlur = value => {
        const [num, inpUnit] = unitValue(value);
        if (value && defaultUnit && !inpUnit) {
            const newValue = `${num}${getUnit(inpUnit)}`;
            handleChange(newValue);
        } else if (
            value &&
            inpUnit &&
            allowedUnits &&
            !allowedUnits.includes(inpUnit)
        ) {
            const newValue = `${num}${getUnit(inpUnit)}`;
            handleChange(newValue);
        }
    };

    const handleKeyDown = e => {
        const keyCode = e.keyCode;
        if (keyCode === 38) {
            e.preventDefault();
            increment();
        } else if (keyCode === 40) {
            e.preventDefault();
            decrement();
        }
    };

    return (
        <InputWrap width={width}>
            <Input
                onChange={e => handleChange(e.target.value)}
                onBlur={e => handleBlur(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                isPale={!!mqPlaceholder}
                className={className}
                value={defaultVal}
                type={inputType}
                id={inputId}
            />

            <NumberControls>
                <button onClick={increment}>
                    <FontAwesomeIcon icon="chevron-up" />
                </button>
                <button onClick={decrement}>
                    <FontAwesomeIcon icon="chevron-down" />
                </button>
            </NumberControls>
        </InputWrap>
    );
});

export const LabeledUnitInput = ({
    label,
    labelWidth,
    labelPosition,
    ...restOfProps
}) => {
    let labelOptions;
    if (labelPosition === 'inline' && label) {
        labelOptions = { label, labelWidth };
    }
    return (
        <InputGroup {...labelOptions}>
            <UnitInput {...restOfProps} />
        </InputGroup>
    );
};

export default UnitInput;
